import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { LanguageContext } from '../contexts/LanguageContext';
import { getHeadingFontClass } from '../utils/fontUtils';
import SectionLayout from '../components/SectionLayout';

export default function About() {
  const intl = useIntl();
  const { locale } = useContext(LanguageContext);

  return (
    <SectionLayout accent="none" className="about-section-bg">
      <h2
        className="section-title animate-slideInLeft"
        style={{ animationDelay: '0.3s' }}
      >
        {intl.formatMessage({ id: 'about.title' })}
      </h2>
      <p
        className="section-subtitle animate-slideInLeft text-muted-foreground"
        style={{ animationDelay: '0.5s' }}
      >
        {intl.formatMessage({ id: 'about.subtitle' })}
      </p>
      <div className="animate-fadeInUp" style={{ animationDelay: '0.7s' }}>
        <h3
          className={`text-2xl lg:text-4xl font-bold text-foreground mb-6 ${getHeadingFontClass(locale)}`}
        >
          <span className="hidden lg:inline-block whitespace-pre-line leading-relaxed">
            {intl.formatMessage({ id: 'about.description.desktop' })}
          </span>
          <span className="lg:hidden leading-normal">
            {intl.formatMessage({ id: 'about.description.mobile' })}
          </span>
        </h3>
        <p className="text-base sm:text-lg md:text-xl text-muted-foreground font-body leading-loose md:leading-loose">
          {intl.formatMessage({ id: 'about.content' })}
        </p>
      </div>
    </SectionLayout>
  );
}
